export const USER_ACCOUNT = 'UserAccount';
export const ACCESS_TOKEN = 'user_token';
export const PLAYER_COMPONENT = 'playerComponent';
